import { Result } from "element-ui";

// 'zh-CN' 简体中文
export default {
  common: {
    city: '中国',
    tips: {
      welcome: '您好，欢迎来到',
      hello: "@:common.tips.welcome @:(common.city)!",
    },
    notsaletip: '您访问的信息已失效',
    notsaledescription: '若有注册/购买域名的需求，可访问新网官网查看',
    notsaleLink: '立即访问',
    saledescription: '您访问的域名，正在出售',
    saledescriptionen: 'this domain name is for sale!',
    pricetitle: '限时售价',
    pricewhois: 'Whois信息',
    pricename: '所需费用',
    priceunit: '元',
    buy: '立即购买',
    domaintip1: '海量域名数据',
    domaintip2: '快速安全交易',
    domaintip3: '此域名通过新网平台售卖',
    domaintip4: '查看更多在售二手域名',
    footertitle: '我们的优势',
    footerpart1: '品牌信誉',
    footerpart1msg1: '国际知名域名注册服务供应商',
    footerpart1msg2: '为千万级用户提供服务',
    footerpart2: '连续多年市场排名靠前',
    footerpart2msg1: '老牌服务商',
    footerpart2msg2: '累计域名注册量超1000万',
    footerpart3: '丰富的域名服务',
    footerpart3msg1: '域名秒注册，操作更方便',
    footerpart3msg2: '为您提供 域名注册、域名抢注、 一口价 等多种域名服务',
  },
}
